import axiosInstance from "../utils/axios";

export const EditorFileList = async (data) => {
    return await axiosInstance().post(`/fileManagerDemo`, data);
};

export const UploadEditorFiles = async (data) => {
    return await axiosInstance().post(`/uploadEditorFiles`, data);
};